<script setup>

import {computed} from "vue";

const props = defineProps({
    waitingPercentage: {
        type: Number,
    },
});

const spinnerColor = computed(() => {
    return {
        'background-color': themeSettings?.elements?.EE_forms?.CE_loading_color?.value || themeSettings?.general?.main_color?.value || '#F0A724'
    };
});

const percentageColor = computed(() => {
    return {
        'color': themeSettings?.elements?.EE_forms?.CE_loading_color?.value || themeSettings?.general?.main_color?.value || '#F0A724'
    };
});
</script>

<template>
    <div class=" w-100 d-flex align-content-center justify-content-center flex-wrap mb-12">
        <div class="spinner-wrapper">
            <div class="percent" :style="percentageColor">{{ waitingPercentage }}%</div>
            <div class="spinner">
                <!-- Dots -->
                <div class="dot" style="--i: 0;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 1;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 2;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 3;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 4;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 5;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 6;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 7;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 8;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 9;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 10;" :style="spinnerColor"></div>
                <div class="dot" style="--i: 11;" :style="spinnerColor"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="css">
.spinner-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    width: 120px;
    height: 120px;
    animation: spin 3s linear infinite;
}

.dot {
    --dot-size: 16px;
    --total: 12;
    position: absolute;
    width: var(--dot-size);
    height: var(--dot-size);
    border-radius: 50%;
    top: 50%;
    left: 50%;
    margin: calc(-1 * var(--dot-size) / 2);
    transform: rotate(calc(30deg * var(--i))) translate(0, -45px);
    opacity: calc(1 - var(--i) / var(--total));
}

.percent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 18px;
    font-weight: bold;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}
</style>
